// ──────────────────────────────────────────────────────────────────────────
// LE VIBRAZIONI
//
// Una pagina web non ha le vibrazioni tattili delle app — il tick secco
// della tastiera, il clic di un selettore: ha solo "accendi il motore per
// tanti millisecondi". Quello che si può scegliere è la durata, e più è
// corta più somiglia a un tick: un ronzio da cento millisecondi si sente
// come una notifica, uno da dodici come un tasto.
//
// Chrome su Android non vibra col telefono in silenzioso, e su iPhone il
// comando non esiste: la vibrazione accompagna, non è mai l'unico segno che
// qualcosa è successo.
// ──────────────────────────────────────────────────────────────────────────

const TICK = 12

export const HAPTICS = {
	// un tocco che ha fatto qualcosa: il + che apre la nuova lezione
	tick: [TICK],
	// un salto: due tick, come la doppia freccia che compare
	jump: [TICK, 70, TICK],
}

export const haptic = kind => {
	try {
		if (typeof navigator !== "undefined" && "vibrate" in navigator)
			navigator.vibrate(HAPTICS[kind] ?? HAPTICS.tick)
	} catch {
		// un browser che la nega non deve rompere il bottone
	}
}
